import { render, staticRenderFns } from "./LogoGithubIcon.vue?vue&type=template&id=457553ca&"
import script from "./LogoGithubIcon.vue?vue&type=script&lang=js&"
export * from "./LogoGithubIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports